export default __webpack_public_path__ + "static/media/card3.78530c97.png";